

import { Navigate } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  requiredRole: 'Manager' | 'Employee';
};

const ManagerRoute = ({
  children,
  requiredRole,
}: Props) => {
  const token = localStorage.getItem('token');

  // User is not logged in
  if (!token) {
    return (
      <Navigate
        to="/Login"
        replace
      />
    );
  }

  const currentRole = localStorage.getItem('role');

  // User does not have required role
  if (currentRole !== requiredRole) {
    return (
      <Navigate
        to="/Login"
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ManagerRoute;